<template>
  <div class="report" v-if="reportLoaded" id="report">
    <C3 v-if="report.origin==='C3'" :report="report"/>
    <C4 v-if="report.origin==='C4'" :report="report"/>
  </div>
</template>

<script>
import C3 from "../reports/C3";
import C4 from "../reports/C4";
import socrata from '@/SocrataDataService';
import {publicApp as app} from '@/main';

export default {
  name: "Report",
  components: {C3, C4},
  data() {
    return {
      report: {user_data: {}, committee: {}, metadata: {}},
      columns: [],
      categoryList: [],
      originalTitle: "",
      reportLoaded: false
    }
  },
  created() {
    this.loadReport(this.$route.params.report_number);
  },
  methods: {
    async loadReport(report_number) {
      this.report = await socrata.getReport('REPORTING_HISTORY', {report_number});
      if (!this.report) {
        this.reportLoaded = true;
        return;
      }
      this.report.metadata = this.report.metadata ? JSON.parse(this.report.metadata) : [];
      this.report.attachments = this.report.attachments ? JSON.parse(this.report.attachments) : [];
      const {
        user_data,
        metadata,
        categorylist
      } = await app.$container.dataService.getReportMetadata(this.report.report_number);
      if (!user_data) {
        console.log('No user data found')
      } else {
        this.report.user_data = user_data;
        if (metadata) this.report.metadata = metadata;
        if (categorylist) this.report.categorylist = categorylist;
      }


      const committee_data = await socrata.getCommitteeData('CAMPAIGN_FINANCE_SUMMARY', this.report.committee_id, this.report.election_year);
      if (!committee_data) {
        console.log('No committee data found')
      } else {
        this.report.committee_data = committee_data;
      }
      committee_data.url = committee_data.url.url;

      this.reportLoaded = true;
    },

  }
}
</script>

<style scoped>

</style>